import { z } from 'zod';
import { TypeOfAPIError, TypeOfAPIResponse } from '@ninja/api-client';
import { APIFactoryOptions, factory } from '../../config';

const requestSchema = z.object({
	uploadRef: z.string(),
	encryptedJourneyId: z.string(),
	memberId: z.string(),
	type: z.string(),
	file: z.string(),
	updatedOnInGST: z.string().optional(),
	operationType: z.number(),
});

export const responseSchema = z.object({
	fileUrl: z.string(),
	lastUpdatedOn: z.string(),
});

const postDocumentUpload = (options: APIFactoryOptions) =>
	factory(options).createAPIDefinition({
		url: '/document/upload',
		method: 'POST',
		errorCodes: [
			'InvalidDocumentFile',
			'InvalidDocumentFileSize',
			'InvalidDocumentType',
			'ReferenceAlreadyUsed',
			'InvalidRequest',
			'UnableToUpload',
			'ReferenceRequired',
			'InvalidDocumentExtension',
			'InvalidImageFile',
			'InvalidImageFileSize',
			'InvalidImageType',
			'InvalidBnWImage',
		],
		headers: {
			'Content-Type': 'multipart/form-data',
		},
		responseSchema,
		requestSchema,
	});

export type PostDocumentUploadRequest = z.infer<typeof requestSchema>;

export type PostDocumentUploadResponse = TypeOfAPIResponse<ReturnType<typeof postDocumentUpload>>;

export type PostDocumentUploadError = TypeOfAPIError<ReturnType<typeof postDocumentUpload>>;

export default postDocumentUpload;
